import { Controller } from "react-hook-form";
import { FieldProps } from "modules/record/record-producer/types/record-producer-types";
import { TimeFieldInput } from "modules/record/shared/fields/TimeFieldInput";
import { buildRequiredRule, getRequiredFieldMessage } from "../../services/recordProducerValidation";
import { BaseField } from "./BaseField";
import { getFieldHelperText } from "../../services/fieldHelperText";

export const TimeFieldComponent = ({ column, control, baseFieldProps, runtimeProps }: FieldProps) => {
    return (
        <BaseField column={column} required={runtimeProps?.required} hidden={runtimeProps?.hidden} {...baseFieldProps}>
            <Controller
                name={column.name}
                control={control}
                defaultValue={column.default_value && column.default_value !== "" ? column.default_value : undefined}
                rules={{ required: buildRequiredRule(runtimeProps?.required ?? column.is_mandatory, getRequiredFieldMessage(column)) }}
                render={({ field, fieldState }) => (
                    <TimeFieldInput
                        value={field.value ?? null}
                        onChange={field.onChange}
                        disabled={runtimeProps?.readonly}
                        error={!!fieldState.error}
                        helperText={getFieldHelperText(fieldState, runtimeProps)}
                    />
                )}
            />
        </BaseField>
    );
};
